var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('v-row',{staticClass:"d-flex flex-column",staticStyle:{"position":"absolute","bottom":"20px","right":"20px"},attrs:{"id":"footnote"}},[_c('span',{staticStyle:{"font-size":"10px"}},[_vm._v("© 2022-2026 Casa dos Reclamos, Todos os direitos reservados.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }